import { render, staticRenderFns } from "./MoviesTen.vue?vue&type=template&id=6639f2c2&scoped=true&"
import script from "./MoviesTen.vue?vue&type=script&lang=js&"
export * from "./MoviesTen.vue?vue&type=script&lang=js&"
import style0 from "./MoviesTen.vue?vue&type=style&index=0&id=6639f2c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6639f2c2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VTextField})
